import mutations from './divisionMutations';
import actions from './divisionActions';
import getters from './divisionGetters';

const state = {
  remDivisionList: [],
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/vuex/rem/division/divisionStore.js